export class MessageModel {
    messageId: number;
    messageThreadId: number;
    senderRole: string;
    messageContent: string;
    createdTime: Date;
  
    constructor(data?:any) {
      this.messageId = data?.messageId ?? 0;
      this.messageThreadId = data?.messageThreadId ?? 0;
      this.senderRole = data?.senderRole ?? "";
      this.messageContent = data?.messageContent ?? "";
      this.createdTime = data?.createdTime ? new Date(data.createdTime) : new Date();
    }
  }